import React from 'react'
import styled, { css, withTheme } from 'styled-components'
import { throttle } from 'lodash'

import Button from './Button'
import Container from './Container'

import config from '../config'
import { buildCTA } from '../utils'

const Wrapper = styled.div`
  width: 100%;
  z-index: 100;
  background: #ececeb;
  transition: transform 0.35s ease;
  box-shadow: 0 10px 10px 0 rgba(0, 0, 0, 0.2);

  ${props =>
    props.active &&
    css`
      position: fixed;
      top: 0;
      transform: translateY(-150%);
    `}

  ${props =>
    props.show &&
    css`
      transform: translateY(0);
    `}
`

const Content = styled.div`
  display: flex;
  align-items: center;
`

const Card = styled.div`
  margin-right: 18px;
`

const Title = styled.div`
  color: ${config.colors.blue};
  font-family: 'Guardian Egyptian Web';
  font-weight: 400;
  font-style: normal;
  font-stretch: normal;
  font-size: 25px;
  line-height: 1;
  margin-right: 20px;
  white-space: nowrap;

  /* Target Edge to slightly reposition title. */
  @supports (-ms-ime-align: auto) {
    position: relative;
    top: -1px;
  }

  ${props =>
    (props.theme.name === 'blue' || props.theme.name === 'platinum') &&
    css`
      font-family: 'BentonSans';
      font-weight: 900;
    `}

  ${props =>
    props.theme.name === 'platinum' &&
    css`
      color: #53565a;
      text-transform: uppercase;
    `}

  ${props =>
    props.theme.name === 'blue' &&
    css`
      color: ${config.colors.lightblue};
    `}

  ${props =>
    props.theme.name === 'payback' &&
    css`
      font-family: 'PAYBACK_Regular';
      font-weight: normal;

      @media (max-width: 470px) {
        display: none;
      }
    `}

  @media (max-width: 980px) {
    font-size: 20px;
  }

  @media (max-width: 480px) {
    font-size: 18px;
  }

  @media (max-width: 400px) {
    display: none;
  }
`

const TitleMeta = styled.span`
  display: none;
  font-size: 14px;
  font-family: 'BentonSans';
  font-weight: bold;
  text-transform: none;

  ${props =>
    props.theme.name === 'blue' &&
    css`
      color: #53565a;
    `}

  ${props =>
    props.theme.name === 'payback' &&
    css`
      font-family: 'PAYBACK_Regular';
      font-weight: normal;
    `}

  @media (max-width: 980px) {
    display: block;
  }

  @media (max-width: 480px) {
    display: none;
  }
`

const Main = styled.div`
  font-size: 16px;
  color: ${config.colors.blue};

  ${props =>
    props.spaceEvenly &&
    css`
      flex: 1%;

      > ul {
        display: flex;
        justify-content: space-evenly;
      }
    `}

  ${props =>
    props.theme.name === 'blue' &&
    css`
      color: #53565a;
    `}

  @media (max-width: 980px) {
    display: none;
  }

  ${props =>
    props.theme.name === 'platinum' &&
    css`
      li {
        color: #53565a;
      }
    `}
`

const Action = styled.div`
  margin-left: auto;

  @media (max-width: 980px) {
    margin-right: -30px;
  }

  @media (max-width: 660px) {
    margin-right: -20px;
  }

  @media (max-width: 460px) {
    margin-right: -16px;
  }
`

const CardImg = styled.img`
  display: block;
`

class StickyBar extends React.Component {
  _isMounted = false

  state = {
    show: false,
    active: false,
  }

  constructor(props) {
    super(props)
    this.myRef = React.createRef()
  }

  componentDidMount() {
    this._isMounted = true

    if (this.myRef && this.myRef.current) {
      this.scrollTop = this.myRef.current.offsetTop
    }

    this.setState({
      active: true,
    })

    window.addEventListener('scroll', throttle(this.handleScroll, 150), {
      passive: true,
    })
  }

  componentWillUnmount() {
    this._isMounted = false
    window.removeEventListener('scroll', this.handleScroll)
  }

  handleScroll = () => {
    if (!this._isMounted) {
      return
    }

    const lastScrollY = window.pageYOffset

    const show = lastScrollY > this.scrollTop
    this.setState({
      show,
    })
  }

  render() {
    const {
      card,
      title,
      mobileSubline,
      content,
      variant,
      spaceEvenly = false,
    } = this.props

    return (
      <Wrapper
        active={this.state.active}
        show={this.state.show}
        ref={this.myRef}>
        <Container>
          <Content>
            <Card>
              <CardImg
                src={card.src}
                srcSet={card.srcSet}
                height={card.height}
                width={card.width}
                alt=""
              />
            </Card>
            <Title>
              {title}
              <TitleMeta>{mobileSubline}</TitleMeta>
            </Title>
            <Main spaceEvenly={spaceEvenly}>{content}</Main>
            <Action>
              <Button small href={buildCTA(variant)}>
                Jetzt beantragen
              </Button>
            </Action>
          </Content>
        </Container>
      </Wrapper>
    )
  }
}

export default withTheme(StickyBar)
